import React from 'react';
export function Divider() {
  return <div className="h-px bg-gradient-to-r from-transparent via-gold-dark/40 to-transparent my-0 relative z-10" aria-hidden="true" data-id="element-52" />;
}